import {Component, computed, input} from '@angular/core'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {faCheck} from '@fortawesome/pro-solid-svg-icons/faCheck'
import {faArrowRight} from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {NgClass} from '@angular/common'

export interface ProgressStep {
  text: string
  icon?: IconDefinition
  done?: boolean
  skipped?: boolean
  active?: boolean
  subSteps?: ProgressStep[]
}

@Component({
  selector: 'cft-progress-stepper',
  templateUrl: './progress-stepper.component.html',
  styles: [
    `
      @reference '../../../styles/app-reference.css';

      :host {
        @apply block;
      }

      .active {
        @apply size-[40px] min-w-[40px] border-2 border-gold-200 bg-gold-500 text-base font-bold;
      }

      .done {
        @apply size-[26px] min-w-[26px] border-2 border-green-200 bg-green-500 text-sm font-medium;
      }

      .skipped {
        @apply size-[26px] min-w-[26px] border-2 border-grey-200 bg-grey-300 text-sm;
      }

      .default {
        @apply size-[12px] bg-president-100;
      }

      .step-text {
        @apply flex flex-col gap-2xs text-center text-xs;
      }
    `,
  ],
  imports: [FaIconComponent, NgClass],
  standalone: true,
})
export class ProgressStepperComponent {
  steps = input.required<ProgressStep[]>()
  activeStep = input<number>()

  protected readonly computedSteps = computed<ProgressStep[]>(() => {
    const steps = this.steps()
    const lastDoneStep = steps
      .slice()
      .reverse()
      .find(s => s.done)
    const activeStep = this.activeStep() ?? (lastDoneStep ? steps.indexOf(lastDoneStep) + 2 : 0)
    return steps.map((s, i) => ({
      text: s.text,
      done: s.done === true || s.done === false ? s.done : i < activeStep - 1 && !s.skipped,
      active: s.active === true || s.active === false ? s.active : i === activeStep - 1,
      skipped: s.skipped,
      icon: s.icon,
      subSteps: s.subSteps,
    }))
  })

  readonly checkMarkIcon = faCheck
  readonly skipIcon = faArrowRight
}
